<template>
  <div>
    <v-layout class="scroll-layout">
      <template v-for="trainer in options">
        <v-card class="name-card" :class="{selected: value==trainer.id}">
        <v-card-text>
          <div class="layout ma-0 align-center column">
            <v-avatar size="120" color="primary">
              <img width="200" v-if="trainer.avatar_thumbnail" :src="trainer.avatar_thumbnail" />
              <img width="200" v-if="!trainer.avatar_thumbnail" src="@/assets/img/avatar.png" />
            </v-avatar>
          </div>
            <div>
              <div class="subheading">{{trainer.full_name}}</div>
              <div class="caption">{{trainer.about}}</div>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="$emit('input', trainer.id)">Wybierz</v-btn>
        </v-card-actions>
      </v-card>
      </template>
    </v-layout>
    <div v-if="hasErrors('trainer')" class="error--text text-xs-center">
        Musisz wybrać trenera.
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: Array,
    value: Number,
    formErrors: Object
  },
  methods: {
    hasErrors (name) {
      return this.formErrors[name] !== undefined && this.formErrors[name].length > 0
    },
    getErrors (name) {
      return this.formErrors[name] || []
    }
  }
}
</script>
<style lang="scss">
.layout.scroll-layout {
  overflow: auto;
  margin: 10px 20px;
}

.v-card.name-card {
  width: 20%;
  margin: 20px;
  display: flex;
  min-width: 250px;
  flex-direction: column;
  justify-content: space-between;

  &.selected {
    background: #0277bd;
    color: white;
  }

  .subheading {
    margin: 20px 0px;
    text-align: center;
  }
  .caption {
    white-space: pre-wrap;
    overflow: auto;
  }
}

@media(max-width: 960px) {
  .layout.scroll-layout {
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media(min-width: 960px) {
  .caption {
    max-height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/runners/TrainerSelection.vue